import React, { useState, Component } from 'react';
import Simplifier from './Simplifier.js';
import ParameterMod from 'components/effects/ParameterMod';
import NewParameterMod from 'components/effects/NewParameterMod';
import {FM_SYNTH} from 'constants/instrument-types.js';
import '../../SynthMods.scss';

const SynthMods = (props) => {
    const [mods, setMods] = useState(0);
    let instrument = props.instrument;
    let oscillators = {};
    let envelopes = {};
    if (instrument.getInstrumentType() == FM_SYNTH) {
        oscillators = {
            'Carrier Oscillator': instrument.carrierOscillator,
            'Modulator Oscillator': instrument.modulatorOscillator
        };
    } else {
        let osc1 = instrument.oscillatorNodes[0];
        let osc2 = instrument.oscillatorNodes[1];
        let osc3 = instrument.oscillatorNodes[2];
        let osc4 = instrument.oscillatorNodes[3];
        oscillators = {
            'Oscillator 1': osc1,
            'Oscillator 2': osc2,
            'Oscillator 3': osc3,
            'Oscillator 4': osc4
        };
        let ampEnvelope = instrument.ampEnvelope;
        let filterEnvelope = instrument.filterEnvelope;
        let pitchEnvelope = instrument.pitchEnvelope;
        envelopes = {
            'Amp Envelope': ampEnvelope,
            'Filter Envelope': filterEnvelope,
            'Pitch Envelope': pitchEnvelope
        };
    }

    return (
        <div className="synth-mods">
          <Simplifier setMods={setMods} instrument={instrument}/>
          <SynthModsSection name={"Synth"} parameters={instrument.parameters}/>
          {Object.keys(oscillators).map(
              key => <SynthModsSection name={key} parameters={oscillators[key].parameters}/>)}
          {Object.keys(envelopes).map(
              key => <SynthModsSection name={key} parameters={envelopes[key].parameters}/>)}
        </div>
    );
};

class SynthModsSection extends Component {
    get parameterMods() {
        let mods = [];
        this.props.parameters
            .forEach(p => mods = mods.concat(p.parameterMods));
        return mods;
    }

    render() {
        let mods = this.parameterMods;
        if (mods.length === 0) {
            return (<div></div>);
        }

        return (
            <div>
              <div className="synth-mods-name">
                {this.props.name}
              </div>
              {mods.map(
                  parameterMod =>
                      <ParameterMod parameterMod={parameterMod}/>
              )}
            </div>
        );
    }
}

export default SynthMods;
